import { object } from "@/common/object.util";
import ApiAdmin from "@/services/apiAdmin.service";
import {
  FETCH_ALL,
  FETCH_ALL_USO_COBRANCAS,
  SAVE_CUSTOMER,
  GET_CUSTOMER_ID
} from "@/store/actions/actions.type";
import {
  SAVE_CUSTOMER_START,
  SAVE_CUSTOMER_END,
  FETCH_ALL_START,
  FETCH_ALL_END,
  SET_ALL_MYPAGAMENTOS,
  SET_ALL_RELATORIO_PAGAMENTOS_POR_USO
} from "@/store/mutations/mutations.type";

const defaults = Object.freeze({
  myPayments: {
    current_page: 1,
    per_page: 10,
    data: [],
    filters: []
  }
});

const state = {
  isCreatingCustomer: false,
  myPayments: object.clone(defaults.myPayments),
};
const getters = {
  isCreatingCustomer(state) {
    return state.isCreatingCustomer;
  },
  myPayments(state) {
    return state.myPayments;
  },
 
};

const actions = {
  [GET_CUSTOMER_ID](context, params) {
    return new Promise((resolve, reject) => {
      if (params) {
        ApiAdmin.get("payments/customers/get/customerId", params)
          .then(response => {
            resolve(response.data.id);
          })
          .catch(e => {
            reject(e.response);
          })
          .finally(() => {});
      }
    });
  },
  [SAVE_CUSTOMER](context, orgId) {
    return new Promise((resolve, reject) => {
      context.commit(SAVE_CUSTOMER_START);
      ApiAdmin.post(`payments/customers/manage/asaas/${orgId}`)
        .then(response => {
          resolve(response);
        })
        .catch(e => {
          reject(e.response);
        })
        .finally(() => {
          context.commit(SAVE_CUSTOMER_END);
        });
    });
  },
  [FETCH_ALL](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_ALL_START);
      ApiAdmin.query("pagamentos/list", params)
        .then(response => {
          context.commit(SET_ALL_MYPAGAMENTOS, response.data);
          resolve();
        })
        .catch(e => {
          console.log(e);
          reject(e.response.data);
        })
        .finally(() => {
          context.commit(FETCH_ALL_END);
        });
    });
  },

};

const mutations = {
  [SAVE_CUSTOMER_END](state) {
    state.isCreatingCustomer = false;
  },
  [SAVE_CUSTOMER_START](state) {
    state.isCreatingCustomer = true;
  },
  [FETCH_ALL_START](state) {},
  [FETCH_ALL_END](state) {},
  [SET_ALL_MYPAGAMENTOS](state, myPayments) {
    state.myPayments = myPayments;
  },
 
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
